import { Accordion, Alert, Button, Loader, Title } from '@mantine/core'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { ShowAccessShared } from './ShowAccessShared'
import { axiosWrapper } from './utils'

export type ApiAccess = {
    consent: boolean
    hasAccess: boolean
    scopes: string
    user: {
        displayName: string
        mail: string
    }
}

export const ShowAccess = ({ access, refetch }: { access: ApiAccess, refetch: () => void }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['messages'],
        queryFn: () => axiosWrapper(axios({
            url: `/api/messages`,
        })),
    })

    const { mutate, isPending } = useMutation({
        mutationFn: () => axiosWrapper(axios({
            url: `/api/logout`,
            method: 'POST',
        })),
        onSuccess: () => {
            refetch()
        },
    })

    return (
        <div>
            <Button color="red" onClick={() => mutate()} loading={isPending} style={{ float: 'right' }} variant="outline">
                Logout
            </Button>

            <div>Name: <strong>{access.user.displayName}</strong></div>
            <div>Email: <strong>{access.user.mail}</strong></div>
            <div>Scopes: <strong>{access.scopes}</strong></div>

            <Title order={4} mt={50} mb="md">Testing personal mail access</Title>
            <div>
                {error && (
                    <Alert color="red" mt="md">
                        Error! {JSON.stringify(error)}
                    </Alert>
                )}
                {(!data || isLoading) ? (
                    <Loader />
                ) : (
                    <Accordion>
                        {data?.value?.map(item => (
                            <Accordion.Item key={item.id} value={item.id}>
                                <Accordion.Control>{item.subject}</Accordion.Control>
                                <Accordion.Panel>
                                    <iframe
                                        srcDoc={item.body?.content || item.bodyPreview}
                                        style={{width: '100%', height: '300px', border: 'none'}}
                                    ></iframe>
                                </Accordion.Panel>
                            </Accordion.Item>
                        ))}
                        {data?.value?.length === 0 && (
                            <Alert color="cyan" mt="md">
                                No emails found in the mailbox.
                            </Alert>
                        )}
                    </Accordion>
                )}
            </div>

            <Title order={4} mt={50} mb="md">Testing shared mailbox access</Title>
            <ShowAccessShared />
        </div>
    )
}
